import { ContentTileComponent, ContentTileController } from './components/content_tile/content-tile';

angular
  .module('ui-ng-content-tile', ['ngSanitize', 'ngAria'])
  .controller('ContentTileController', ContentTileController)
  .component('contentTile', new ContentTileComponent());
export * from './components/content_tile/content_tile_types';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-content-tile/src/main.ts